import { Component } from '@angular/core';

@Component({
    selector: 'error-pagenotfound',
    templateUrl: './pagenotfound.component.html',
    styles: [],
    standalone: false
})
export class PageNotFoundComponent {
    constructor() { }
}